import { makeStyles } from "@material-ui/core";
import { COLORS } from "../../../config/theme/theme";

const currentConfigStyle = makeStyles({
  root: {
    marginTop: "80px",
    padding: "24px 12px 24px 24px",
  },
  tabPanelStyle: {
    padding: "12px 0px 0px 0px",
    overflow: "auto",
    height: "calc(100vh - 420px)",
  },
  tabStyle: {
    margin: "6px 8px",
    fontSize: "18px",
  },
  tabsBorder: {
    borderBottom: `2px solid ${COLORS.SECONDARY_DARK}`,
    marginTop: "-2px",
  },
  dFlexEnd: {
    display: "flex",
    justifyContent: "flex-end",
  },
  completeSetupSettingsButton: {
    display: "flex",
    "& img": {
      height: "18px",
      marginLeft: "20px",
    },
  },
  tableCellTrucate: {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  headerStyle: {
    height: "65px",
    position: "sticky",
    top: 0,
    left: 0,
    backgroundColor: COLORS.ATHENS_GRAY,
    padding: "12px 0px 0px 12px",
    margin: 0,
    color: COLORS.EMPEROR,
    fontWeight: 600,
    fontSize: "14px",
    border: "none",
    zIndex: 0,
    minWidth: "100px",
    "&.MuiTableCell-paddingNone:last-child": {
      padding: "12px 12px 0px 12px",
    },
  },
  ScalableItemsSpanStyle: {
    fontWeight: 400,
    fontSize: "12px",
    color: "#0E5AA7",
  },
  searchBoxDivStyle: {
    padding: 0,
    margin: "0px 0px 0px 12px",
  },
  tableStyle: {
    margin: 0,
    marginTop: "24px",
    padding: 0,
    maxHeight: "calc(100vh - 418px)",
    width: "100%",
    overflow: "auto",
  },
  headerRoot: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "24px",
  },
  header: {
    display: "flex",
    justifyContent: "flex-start",
  },
  heading: {
    fontWeight: 600,
    fontSize: "24px",
    color: COLORS.DARK_GRAY,
  },
  buttonStyles: {
    width: "auto",
    height: "40px",
    background: COLORS.DOS_BLUE_DARK,
    color: "#FFFFFF",
    border: "1px solid",
    borderColor: COLORS.DOS_BLUE_DARK,
    borderRadius: "8px",
    fontWeight: 700,
    fontSize: "14px",
    lineHeight: "20px",
    "&:hover": {
      backgroundColor: COLORS.DOS_BLUE_DARK,
      color: "#FFFFFF",
      border: "1px solid",
      borderColor: COLORS.DOS_BLUE_DARK,
      borderRadius: "8px",
    },
    "&:disabled": {
      border: "1px solid rgba(0, 0, 0, 0.12)",
    },
  },
  resetButtonDivStyle: {
    padding: 0,
    paddingRight: "8px",
    margin: 0,
    display: "flex",
    justifyContent: "flex-end",
  },
  resetButtonStyle: {
    width: "212px",
    border: "1px solid #0E5AA7",
    background: "#fff",
    color: "#0E5AA7",
    "&:hover": {
      border: "1px solid #0E5AA7",
      background: "#fff",
      color: "#0E5AA7",
    },
  },
  VehicleTypeLabelSpanStyle: {
    fontWeight: 500,
    fontSize: "0.625rem",
    lineHeight: "1.4em",
    color: "#fff",
  },
  VehicleTypeValueSpanStyle: {
    fontWeight: 600,
    fontSize: "0.625rem",
    lineHeight: "1.4em",
    color: "#fff",
  },
  successSpanStyle: {
    fontSize: "12px",
    fontWeight: 500,
    color: COLORS.PERSIAN_GREEN,
  },
  failureSpanStyle: {
    fontSize: "12px",
    fontWeight: 500,
    color: COLORS.DARK_RED,
  },
  recordSpanStyle: {
    fontSize: "12px",
    fontWeight: 400,
    color: COLORS.TUATARA,
  },
  recordToolTipSpanStyle: {
    fontSize: "12px",
    fontWeight: 400,
    color: COLORS.WHITE,
  },
  toolTipContainerStyel: {
    minWidth: "212px",
    padding: "4px 12px",
  },
  lineHeightStyle: {
    lineHeight: 1.5,
  },
  cellDataStyle: {
    width: "auto",
    height: "40px",
    verticalAlign: "middle",
    color: COLORS.MINE_SHAFT,
    fontWeight: 400,
    fontSize: "12px",
    border: "none",
    borderBottom: `1px solid ${COLORS.MERCURY}`,
    padding: "8px 0px 8px 8px",
    "&.MuiTableCell-paddingNone:last-child": {
      padding: "8px 0px 8px 8px",
    },
    backgroundColor: COLORS.WHITE,
  },
  tablePaginationStyle: {
    bottom: 0,
    justifyContent: "flex-end",
    width: "calc(100vw - 110px)",
    marginBottom: "24px",
    marginLeft: "-2px",
    background: "#E6E6E6",
    borderRadius: "0px 0px 8px 8px",
    minHeight: "54px",
    maxHeight: "54px",
  },
  noDataRowStyle: {
    width: "auto",
    height: "300px",
    verticalAlign: "middle",
    textAlign: "center",
    borderRadius: "8px",
    border: "none",
    boxShadow: "none",
  },
  toolTipLargeContainerStyle: {
    minWidth: "212px",
    padding: "4px 12px",
  },
  timeConfigContainerStyle: {
    margin: "4px 0px 0px 0px",
    padding: 0,
  },
});

export default currentConfigStyle;
